import OstroDynamicContent from 'app/components/OstroDynamicContent';

import { useContactFormLinkClick } from '../hooks/useContactFormLinkClick';
import { type FormItemText } from '../types';

type ContactFormStaticTextProps = {
  item: FormItemText;
  contactFormSlug: string;
};

const ContactFormStaticText = ({ item, contactFormSlug }: ContactFormStaticTextProps) => {
  const { handleLinkClick } = useContactFormLinkClick(contactFormSlug);

  return (
    <>
      <input
        type="hidden"
        name={item.ref_id}
        value="true"
      />
      <OstroDynamicContent
        dangerouslySetInnerHTML={{ __html: item.label }}
        className="[&_h1]:mb-0 [&_p]:mb-0"
        onClick={handleLinkClick}
      />
    </>
  );
};

export default ContactFormStaticText;
